import { ApiService } from '../../services/api_service';
import { Assistent } from '../dateneingabe/assistent/Assistent';
import { BreadcrumbMainNavigation } from './BreadcrumbMainNavigation';
import { BreadcrumbNavigation } from './BreadcrumbNavigation';
import breadcrumbStyle from './BreadcrumbNavigation.less';
import * as classNames from 'classnames';
import { ClassValue } from 'classnames/types';
import { ContextService } from '../../services/context_service';
import { DataService } from '../../services/data_service';
import { DatenauswertungStandortTabs } from '../datenauswertung/DatenauswertungStandortTabs';
import { Dateneingabe } from '../dateneingabe/Dateneingabe';
import DialogWrapper2 from '../../core/dialog/dialog_wrapper_v2';
import { EditOptionTabs } from '../../login/EditOptionTabs';
// import { Effizienznetzwerk } from '../effizienznetzwerk/Effizienznetzwerk';
import { i18n } from '../../i18n/i18n';
import { i18nLang } from '../../i18n/i18nLang';
import { getLanguageSelect } from '../../i18n/getLanguageSelect';
// import { hasEffizienznetzwerk } from '../helper';
import { IDs } from '../../helpers/IDs';
import { InformationenHilfe } from '../informationen_hilfe/InformationenHilfe';
import { lazyInject } from '../../services/inversify';
import { MainNavigation } from './MainNavigation';
import { MainSelection } from '../../main/MainSelection';
import { Nachhaltigkeit } from '../nachhaltigkeit/nachhaltigkeit';
import { OnlineHilfe } from '../../core/helpSystem/OnlineHilfe';
import * as React from 'react';
import ReactTooltip from 'react-tooltip';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import { SectionStyle } from '../../helpers/SectionStyle';
import { SideNavigation } from './SideNavigation';
import style from './StartTabsHeader.less';
import { SubHeader } from './SubHeader';
import { TriggerService } from '../../core/trigger/trigger_service';
import { Zusatztools } from '../zusatztools/ZusatzTools';

interface StartTabsHeaderProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    reloadData: () => void;
    standortSelected: any;
    modulSelected: string;
    openModulSelection: () => void;
    lang: string;
    setLanguage: (lang: string) => void;
    renderUnternehmenAuswahl: () => JSX.Element;
    routing: any;
}

interface StartTabsHeaderState {
    tabIndex: number;
    showEditUser: boolean;
    showSelectTools: boolean;
    showSelectLanguage: boolean;
}

export class StartTabsHeader extends React.Component<StartTabsHeaderProps, StartTabsHeaderState> {

    constructor(props: any) {
        super(props);
        this.state = {
            tabIndex: this.contextService.get('tabIdxStartTabsHeader') || 0,
            showEditUser: false,
            showSelectTools: false,
            showSelectLanguage: false
        };

        this.setOnClickNaviBtns = this.setOnClickNaviBtns.bind(this);
        this.unsetOnClickNaviBtns = this.unsetOnClickNaviBtns.bind(this);
        this.onChangeModulSelection = this.onChangeModulSelection.bind(this);
    }

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(ContextService) private contextService: ContextService;
    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    private tabRoutings: any[] = [
        { path: RoutingIDs.ROUTE_DATENEINGABE },
        { path: RoutingIDs.ROUTE_DATENAUSWERTUNG },
        // { path: RoutingIDs.ROUTE_EFFIZIENZNETZWERK },
        { path: RoutingIDs.ROUTE_ZUSATZTOOLS },
        { path: RoutingIDs.ROUTE_INFORMATIONEN_HILFE }
    ];

    private onClickNaviBackBtn: () => void;
    private onClickNaviNextBtn: () => void;

    componentDidMount(): void {
        this.checkRouting();
    }

    componentDidUpdate(prevProps: any): void {
        if (this.props.routing !== prevProps.routing) {
            this.checkRouting();
        }
    }

    checkRouting(): void {
        const routing: any = this.props.routing || {};
        if (routing.path && routing.path.selectedMenu >= 0) {
            this.setTabIndex(routing.path.selectedMenu, routing);
        }
    }

    render(): JSX.Element {
        // console.log('render Start: ', this.props.modulSelected);
        const data: any = this.props.data || {};
        const konfiguration: any = (data[IDs.ENT_KONFIGURATION] || [])[0] || {};
        const modul: string = data.MODUL_SELECTED || null;
        // const disabledEffizienznetzwerk: boolean = !hasEffizienznetzwerk(this.props.data);
        const disabledZusatztools: boolean = modul === 'cfm';
        const showGefuehrterModus: boolean = konfiguration.gefuehrter_modus_orig === 1;
        const tabDisabled: boolean[] = [
            false,
            false,
            // true/*disabledEffizienznetzwerk*/,
            disabledZusatztools,
            false
        ];
        return (
            <div className={style.outer}>
                <div className={style.header}>
                    <div className={style.left}>{this.renderLeft()}</div>
                    <div className={style.middle}>{this.renderMiddle(tabDisabled)}</div>
                    <div className={style.right}>{this.renderRight(showGefuehrterModus)}</div>
                </div>
                <SubHeader
                    data={this.props.data}
                    onRoutingChange={this.props.onRoutingChange}
                    reloadData={this.props.reloadData}
                    routing={this.props.routing}
                    standortSelected={this.props.standortSelected}
                    // onClickNaviBackBtn={this.onClickNaviBackBtn}
                    // onClickNaviNextBtn={this.onClickNaviNextBtn}
                    // -> Die Initialisierungsinstanz wird immer verwendet -> Probleme beim Tab-Wechseln.
                    // Die aktuelle Instanz wird verwendet -> In Ordnung.
                    onClickNaviBackBtn={typeof this.onClickNaviBackBtn === 'function' ? () => this.onClickNaviBackBtn() : () => { }}
                    onClickNaviNextBtn={typeof this.onClickNaviNextBtn === 'function' ? () => this.onClickNaviNextBtn() : () => { }}
                    isGefuehrterModus={showGefuehrterModus && this.state.tabIndex === 0}
                    hideNavi={this.props.modulSelected === 'selection'}
                />
                <div style={{ display: 'flex', flex: 1, flexDirection: 'row', overflowY: 'hidden' }}>
                    {this.props.modulSelected === 'selection' && <>
                        <div className={style.sidenavigation}>
                            <MainNavigation
                                data={this.props.data}
                                id={4}
                                onModulSelection={this.onChangeModulSelection}
                                onRoutingChange={() => null}
                            />
                        </div>
                        <div
                            className={style.content}
                            style={{ paddingLeft: 20, overflow: 'hidden' }}
                        >
                            <BreadcrumbMainNavigation
                                data={this.props.data}
                                style={{ marginBottom: 0 }}
                            />
                            <MainSelection
                                modulSelected={this.props.modulSelected}
                                data={this.props.data}
                                onModulSelection={this.onChangeModulSelection}
                            />
                        </div>
                    </>}
                    {(this.props.modulSelected === 'nachhaltigkeit' || (modul === 'nachhaltigkeit' && this.props.modulSelected !== 'selection')) && <>
                        <div className={style.sidenavigation} />
                        <div
                            className={style.content}
                            style={{ minHeight: 0, paddingLeft: 20, display: 'flex', flex: 1, flexDirection: 'column', overflowY: 'auto' }}
                        >
                            <div className={breadcrumbStyle.breadcrumb_navigation}>
                                <div>{i18n('Nachhaltigkeit', 'sys')}</div>
                            </div>
                            <div style={{ flexDirection: 'column', display: 'flex', minHeight: 0, flex: 1 }}>
                                <Nachhaltigkeit data={this.props.data} />
                            </div>
                        </div>
                    </>}
                    {(['nachhaltigkeit', 'selection'].indexOf(this.props.modulSelected) === -1) && modul !== 'nachhaltigkeit' &&
                        <>
                            {(!showGefuehrterModus || this.state.tabIndex > 0) &&
                                <div className={style.sidenavigation}>
                                    <SideNavigation
                                        data={this.props.data}
                                        id={this.state.tabIndex}
                                        onRoutingChange={this.props.onRoutingChange}
                                    />
                                </div>
                            }
                            <div
                                className={style.content}
                                style={{
                                    ...(showGefuehrterModus && this.state.tabIndex === 0
                                        ? { paddingLeft: 0, paddingRight: 0 }
                                        : { /*paddingLeft: 20*/ }
                                    )
                                }}
                            >
                                {this.renderBreadcrumbNavigation()}
                                {this.renderContent(tabDisabled)}
                            </div>
                        </>
                    }
                </div>
                {this.renderDialogEditOptionTabs()}
                {this.renderDialogSelectTools()}
            </div>
        );
    }

    renderBreadcrumbNavigation(): JSX.Element {
        const showGefuehrterModus: boolean = ((this.props.data[IDs.ENT_KONFIGURATION] || [])[0] || {}).gefuehrter_modus_orig === 1;
        if (!this.state.tabIndex && showGefuehrterModus) {
            return null;
        }
        return (
            <div style={{ paddingLeft: 20 }}>
                <BreadcrumbNavigation
                    data={this.props.data}
                    id={this.state.tabIndex}
                    onRoutingChange={this.props.onRoutingChange}
                />
            </div>
        );
    }

    renderDialogEditOptionTabs(): JSX.Element {
        if (!this.state.showEditUser) {
            return null;
        }

        return (
            <DialogWrapper2
                title='Einstellungen'
                width={-1}
                containerId='einstellungen'
                onAfterClose={() => this.setState({ showEditUser: undefined })}
            >
                <EditOptionTabs
                    containerId='einstellungen'
                    data={this.props.data}
                    onRoutingChange={this.props.onRoutingChange}
                    initialTab={0}
                    onClose={() => this.setState({ showEditUser: undefined })}
                />
            </DialogWrapper2>
        );
    }

    renderDialogSelectTools(): JSX.Element {
        if (!this.state.showSelectTools) {
            return null;
        }

        return (
            <DialogWrapper2
                title='Tools wechseln'
                width={-1}
                containerId='unternehmen'
                onAfterClose={() => this.setState({ showSelectTools: undefined })}
            >
                <div style={{ padding: 10, overflowY: 'auto' }}>
                    {this.props.renderUnternehmenAuswahl()}
                </div>
            </DialogWrapper2>
        );
    }

    renderLanguageSelect(): JSX.Element {
        if (!this.state.showSelectLanguage) {
            return <></>;
        }
        return (
            <div className={`cont-${SectionStyle.getCurrentId()}`} style={{ top: 55, position: 'absolute', zIndex: 999 }}>
                {getLanguageSelect(this.props.lang, (lang: string) => {
                    this.setState({ showSelectLanguage: false });
                    if (this.props.lang !== lang) {
                        this.props.setLanguage(lang);
                    }
                })}
            </div>
        );
    }

    renderLeft(): JSX.Element {
        const logo = require(`../../icons/logos/${this.getLogoFile()}`);
        const bereich_key: string = ((this.props.data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).bereich_key_orig || null;
        let bereich_kuerzel = 'SO'
        if (bereich_key === 'handwerk') {
            bereich_kuerzel = 'HW';
        } else if (bereich_key === 'kultur') {
            bereich_kuerzel = 'KU';
        }
        let lstyle: any = {};
        if (bereich_kuerzel === 'SO') {
            lstyle = { height: 60 };
        } else {
            lstyle = { width: 200 }
        }
        return <div className={style.leftInner}>
            <img src={logo} style={lstyle} alt='' />
        </div>;
    }

    getLogoFile(): string {
        const bereich_key: string = ((this.props.data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).bereich_key_orig || null;
        let bereich_kuerzel = 'SO';
        if (bereich_key === 'handwerk') {
            bereich_kuerzel = 'HW';
        } else if (bereich_key === 'kultur') {
            bereich_kuerzel = 'KU';
        }
        let tabname = 'Eingabe';
        if (this.state.tabIndex === 1 || this.props.modulSelected === 'selection') {
            tabname = 'Auswertung';
        // } else if (this.state.tabIndex === 2) {
        //     tabname = 'Auswertung'; // Effizienznetzwerk
        } else if (this.state.tabIndex === 2) {
            tabname = 'Zusatztools';
        } else if (this.state.tabIndex === 3) {
            tabname = 'Hilfe';
        }
        return `${bereich_kuerzel}_Logo_${tabname}.png`;
    }

    renderMiddle(tabDisabled: boolean[]): JSX.Element {
        const icon_eingabe = require('../../icons/100px/edit100.png');
        const icon_auswertung = require('../../icons/100px/auswertung100.png');
        const icon_zusatztools = require('../../icons/100px/zusatztools100.png');
        const icon_info = require('../../icons/100px/help100.png');
        const regi = (this.props.data[IDs.ENT_REGISTRIERUNG] || [])[0] || {};
        const unternehmen: string = ((this.props.data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).name
            || (this.props.data.RES_MAIN_LOAD_UNTERNEHMEN_SEL || {}).bezeichnung || '';
        const name = (regi.vorname || regi.name) ? `${regi.vorname || ''} ${regi.name || ''} (${unternehmen})` : unternehmen;

        return <>
            <div className={style.middle_top}>
                {this.props.modulSelected !== 'selection' && `Hallo ${name}`}
            </div>
            <div className={style.middle_bottom}>
                {this.props.modulSelected !== 'selection' && (this.props.data || {}).MODUL_SELECTED !== 'nachhaltigkeit' && <>
                    {this.renderTab(0, 'Eingabe', tabDisabled[0] ? style.tabHidden : style.tab0, icon_eingabe)}
                    {this.renderTab(1, 'Auswertung', tabDisabled[1] ? style.tabHidden : style.tab1, icon_auswertung)}
                    {/* {this.renderTab(2, 'Effizienznetzwerk', tabDisabled[2] ? style.tabHidden : style.tab2, icon_auswertung)} */}
                    {this.renderTab(2, 'Zusatztools', tabDisabled[2] ? style.tabHidden : style.tab2, icon_zusatztools)}
                    {this.renderTab(3, 'Hilfe / FAQ', tabDisabled[3] ? style.tabHidden : style.tab3, icon_info)}
                </>}
            </div>
        </>;
    }

    renderTab(idx: number, title: string, tabCls: ClassValue, img: any): JSX.Element {
        const arrCls = [style.tab, tabCls];
        if (this.state.tabIndex === idx) {
            arrCls.push(style.tabSelected);
        }
        return <div
            className={classNames(arrCls)}
            onClick={() => this.setTabIndex(idx, this.tabRoutings[idx])}
        >
            <div style={{ width: 20 }}>
                <img src={img} style={{ height: 16 }} alt='' />
            </div>
            <div>
                {i18n(title, 'tab')}
            </div>
        </div>;
    }

    renderRight(showGefuehrterModus: boolean): JSX.Element {
        const modul: string = this.props.data.MODUL_SELECTED || null;
        return <>
            <div className={style.right_top}>
                {showGefuehrterModus ? '' : i18n('Expertenmodus')}
            </div>
            <div className={style.right_bottom}>
                <div
                    className={style.tabFunction}
                    onClick={this.props.openModulSelection}
                    data-for='buf_func_home'
                    data-tip={i18n('Startseite', 'sys')}
                />
                <div
                    className={style.tabFunction}
                    onClick={() => this.setState({ showEditUser: true })}
                    data-for='buf_func_einstellungen'
                    data-tip={i18n('Einstellungen', 'sys')}
                />
                {modul !== 'steuer' &&
                    <div
                        className={style.tabFunction}
                        onClick={() => this.onChangeGefuehrterModus(!showGefuehrterModus)}
                        data-for='buf_func_moduswechsel'
                        data-tip={i18n(`Wechsel in den ${showGefuehrterModus ? 'Expertenmodus' : 'geführten Modus'}`, 'sys')}
                    />
                }
                {(this.apiService.isAdmin() || this.apiService.isBerater() /* || this.apiService.isMainUser() */) &&
                    <div
                        className={style.tabFunction}
                        onClick={() => this.setState({ showSelectTools: true })}
                        data-for='buf_func_tools'
                        data-tip={i18n('Tools wechseln', 'sys')}
                    />
                }
                <div
                    className={style.tabFunction}
                    onClick={this.props.reloadData}
                    data-for='buf_func_reload'
                    data-tip={i18n('Daten neu laden', 'sys')}
                />
                <div
                    className={style.tabFunction}
                    style={{ ...(!this.apiService.isAdmin() && { display: 'none' }) }}
                    onClick={() => this.setState({ showSelectLanguage: true })}
                    data-for='buf_func_language'
                    data-tip={this.state.showSelectLanguage ? null : i18n('Sprache', 'sys')}
                >
                    {this.renderLanguageSelect()}
                </div>
                <div
                    className={style.tabFunction}
                    onClick={() => {
                        if (window.confirm('Wirklich ausloggen?')) {
                            document.cookie = 'access_token= ; path=/';
                            this.apiService.removeTokenLocalStorage();
                            // location.reload();
                            const currentPage = new URL(window.location.href);
                            currentPage.searchParams.set('t', (new Date().getTime()) + '');
                            window.location.href = currentPage.href;
                        }
                    }}
                    data-for='buf_func_logout'
                    data-tip={i18n('Ausloggen', 'sys')}
                />
            </div>
            {this.renderTooltips(['home', 'einstellungen', 'moduswechsel', 'reload', 'language', 'logout', 'tools'])}
        </>;
    }

    renderContent(tabDisabled: boolean[]): JSX.Element {
        if (tabDisabled[this.state.tabIndex]) {
            return null;
        }
        const showGefuehrterModus: boolean = ((this.props.data[IDs.ENT_KONFIGURATION] || [])[0] || {}).gefuehrter_modus_orig === 1;
        switch (this.state.tabIndex) {
            case 0:
                return showGefuehrterModus
                    ? <Assistent
                        data={this.props.data}
                        onRoutingChange={this.props.onRoutingChange}
                        routing={this.props.routing}
                        setOnClickNaviBtns={this.setOnClickNaviBtns}
                        unsetOnClickNaviBtns={this.unsetOnClickNaviBtns}
                    />
                    : <Dateneingabe
                        data={this.props.data}
                        onRoutingChange={this.props.onRoutingChange}
                        reloadData={this.props.reloadData}
                        routing={this.props.routing}
                        standortSelected={this.props.standortSelected}
                    />;
            case 1:
                return <DatenauswertungStandortTabs
                    data={this.props.data}
                    onRoutingChange={this.props.onRoutingChange}
                    reloadData={this.props.reloadData}
                    routing={this.props.routing}
                    standortSelected={this.props.standortSelected}
                />;
            /*
            case 2:
                return <Effizienznetzwerk
                    data={this.props.data}
                    onRoutingChange={this.props.onRoutingChange}
                    reloadData={this.props.reloadData}
                    routing={this.props.routing}
                    standortSelected={this.props.standortSelected}
                />;
            */
            case 2:
                return <Zusatztools
                    data={this.props.data}
                    onRoutingChange={this.props.onRoutingChange}
                    reloadData={this.props.reloadData}
                    routing={this.props.routing}
                    standortSelected={this.props.standortSelected}
                />;
            case 3:
                return <InformationenHilfe
                    data={this.props.data}
                    onRoutingChange={this.props.onRoutingChange}
                    routing={this.props.routing}
                    standortSelected={this.props.standortSelected}
                />;
            default:
                return <div>No content</div>;
        }
    }

    setOnClickNaviBtns(onClickNaviBackBtn: () => void, onClickNaviNextBtn: () => void): void {
        // this.onClickNaviBackBtn = onClickNaviBackBtn;
        // this.onClickNaviNextBtn = onClickNaviNextBtn;
        // -> Die Initialisierungsinstanz wird immer verwendet -> Probleme beim Tab-Wechseln.
        // Die aktuelle Instanz wird verwendet -> In Ordnung.
        this.onClickNaviBackBtn = () => onClickNaviBackBtn();
        this.onClickNaviNextBtn = () => onClickNaviNextBtn();
    }

    unsetOnClickNaviBtns(): void {
        this.onClickNaviBackBtn = () => { };
        this.onClickNaviNextBtn = () => { };
    }

    renderTooltips(ids: string[]): JSX.Element[] {
        return (ids || []).map((id: string) =>
            <div className={`cont-${SectionStyle.getCurrentId()}`}>
                <ReactTooltip
                    className={style.tooltip}
                    id={`buf_func_${id}`}
                    key={`tooltip-${id}`}
                    place='top'
                    type='info'
                    effect='solid'
                />
            </div>
        );
    }

    setTabIndex(tabIndex: number, tabRouting: any): void {
        // console.log('setTabIndex:' , tabIndex);
        if (this.state.tabIndex !== tabIndex) {
            OnlineHilfe.tabIdx = tabIndex;
            SectionStyle.curSectionId = tabIndex;
            this.setState({ tabIndex }, () => {
                this.props.onRoutingChange(tabRouting);
                this.contextService.set('tabIdxStartTabsHeader', tabIndex);
            });
        }
    }

    onChangeGefuehrterModus(value: boolean): void {
        const { data } = this.props;
        if (Array.isArray(data[IDs.ENT_KONFIGURATION]) && data[IDs.ENT_KONFIGURATION].length > 0) {
            const item: any = {
                tid: data[IDs.ENT_KONFIGURATION][0].tid,
                show_gefuehrter_modus: false,
                gefuehrter_modus: value ? 1 : 0
            };
            this.dataService.setData(
                IDs.MOD_ETOOL, IDs.ENT_KONFIGURATION, item,
                () => this.triggerService.fire('reload', IDs.ENT_KONFIGURATION)
            );
        }
    }

    onChangeModulSelection(modul: string) {
        this.props.data.MODUL_ON_SELECT(modul);
        if (modul === 'steuer') {
            const isGefuehrterModus: boolean = ((this.props.data[IDs.ENT_KONFIGURATION] || [])[0] || {}).gefuehrter_modus_orig === 1;
            if (!isGefuehrterModus) {
                setTimeout(() => this.onChangeGefuehrterModus(true), 0);
            }
        }
    }
}
